import { render, staticRenderFns } from "./MultiPageScanner.vue?vue&type=template&id=71979261&scoped=true"
import script from "./MultiPageScanner.vue?vue&type=script&lang=js"
export * from "./MultiPageScanner.vue?vue&type=script&lang=js"
import style0 from "./MultiPageScanner.vue?vue&type=style&index=0&id=71979261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71979261",
  null
  
)

export default component.exports